import { Component, HostListener } from '@angular/core';

import { ApiService } from "../../api.service";
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Crc, Study } from 'src/app/study.model';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from "../../shared/common.service";
declare var bootstrap: any;
@Component({
  selector: 'app-study-crc-view',
  templateUrl: './study-crc-view.component.html',
  styleUrl: './study-crc-view.component.scss'
})
export class StudyViewComponent {



  dtOptions: { pagingType: string; pageLength: number; processing: boolean; ajax: (dataTablesParameters: any, callback: any) => void; columns: { title: string; data: string; }[]; };

  studyInfo: any = {};

  // studyInfo: any[] = [];
  userInfo: any = {};
  studycda: any = {};
  studycsr: any = [];
  EC_Submission: any = [];
  Data_Entry: any = [];

  studydoc: any[] = [];
  studyec: any = {};

  studyip: any = [];
  RUNNING_STATUS: any[] = [];
  studyfeasibility: any = {};
  Close_Out: any = [];
  data: Study[] = [];
  crcsList: Crc[] = [];
  selectedCrcs: Crc[] = [];
  activeTab: string = 'step1';
  scrollOffset: number = 35;
  showSticky: any = false;
  routeParams: any;
  document_sumbmission_to_pi: any;
  CTRI_Done: any;
  CTA: any;
  SITE_INITATION_VISIT_DONE: any;

  
  
  studyId: number;
  previousPage: number;
  addData(newData) {
    this.studycda.push(newData); // Update studycda
    console.log('Updated studycda:', this.studycda); // For debugging
}

  openModal(gridType: string): void {
    let modalId: string;
  
    // Determine which modal to open based on gridType
    if (gridType === 'studyCda') {
      modalId = 'studyCdaModal';
    } else if (gridType === 'cta') { // Added condition for CTA modal
      modalId = 'ctaModal';
    } else if (gridType === 'siteFeasibility') {  // Added Site Feasibility
      modalId = 'siteFeasibilityModal';
    } else if (gridType === 'documentSubmission') {  // Added Document Submission to PI
      modalId = 'documentSubmissionModal';
    } else if (gridType === 'ecSubmission') { // Added condition for EC Submission modal
      modalId = 'ecSubmissionModal';
    } else if (gridType === 'ipNonIp') { // Added condition for IP-NONIP modal
      modalId = 'ipNonIpModal';
    } else if (gridType === 'siteVisitDone') { // Added condition for SITE INITIATION VISIT DONE modal
      modalId = 'siteVisitDoneModal';
    } else if (gridType === 'runningStatus') { // Added condition for Running Status modal
      modalId = 'runningStatusModal';
    } else if (gridType === 'dataEntry') {  // Added condition for Data Entry modal
      modalId = 'dataEntryModal';
    } else if (gridType === 'csrSubmission') {  // Added condition for CSR Submission modal
      modalId = 'csrSubmissionModal';
    } else if (gridType === 'ctriDone') {
      modalId = 'ctriDoneModal';
    } else if (gridType === 'closeOut') {
      modalId = 'closeOutModal';
    }
  
    // Get the modal element by its ID and show the modal
    const modalElement = document.getElementById(modalId);
    if (modalElement) {
      const bootstrapModal = new bootstrap.Modal(modalElement);
      bootstrapModal.show();
    }
  }
  closeModal(gridType: string): void {
    let modalId: string;
  
    // Determine which modal to close based on gridType
    if (gridType === 'ctriDone') {
      modalId = 'ctriDoneModal';
    } else if (gridType === 'closeOut') {
      modalId = 'closeOutModal';
    }
  
    // Get the modal element by its ID and hide the modal
    const modalElement = document.getElementById(modalId);
    if (modalElement) {
      const bootstrapModal = bootstrap.Modal.getInstance(modalElement);
      if (bootstrapModal) {
        bootstrapModal.hide();
      }
    }
  }
  
  

  currentPage: number = 1;
  searchParams: any = {}; // Store search params here
  searchCrcName: string = '';
  searchStudyName: string = '';
  searchLocation: string = '';
  searchAssignedBy: string = '';



  constructor(
    private apiService: ApiService,
    private http: HttpClient,
    private route: ActivatedRoute,
    private commonService: CommonService,
    private router: Router
  ) {

  }


  ngOnInit(): void {
    this.routeParams = this.route.snapshot.params;


this.studyId = +this.route.snapshot.paramMap.get('id');
// Capture the query parameters
this.route.queryParams.subscribe(params => {
 this.currentPage = params['page'] || 1;
 this.searchParams.searchCrcName = params['searchCrcName'] || '';
 this.searchParams.searchStudyName = params['searchStudyName'] || '';
 this.searchParams.searchLocation = params['searchLocation'] || '';
 this.searchParams.searchAssignedBy = params['searchAssignedBy'] || '';
});


    let userData = this.commonService.getUserData();
    if(userData == null){
      this.commonService.logout();
    }
    // const params = new HttpParams().set('userId', '1');
    const headers = new HttpHeaders().set('Authorization', 'Bearer my-token');
    this.apiService.get(`api/getStudyCrcDetail/${this.routeParams.id}`).subscribe((response:any) => {
      this.studyInfo = response.study_info;
      this.userInfo = response.user_info;
      this.studycda = response.CDA[0];
      this.studyfeasibility = response.Site_Feasibility[0];
      this.document_sumbmission_to_pi = response.DOCUMENT_SUBMISSION_TO_PI;
      this.EC_Submission = response.EC_Submission;
      this.CTRI_Done = response.CTRI_Done;
      this.CTA = response.CTA;
      this.studyip = response["IP-NONIP"];
      this.RUNNING_STATUS = response.RUNNING_STATUS;
      this.SITE_INITATION_VISIT_DONE = response.SITE_INITATION_VISIT_DONE;
      this.Data_Entry = response.Data_Entry;

      this.studycsr = response.CSR_Sumbission;

      this.Close_Out = response.Close_Out;



    });


    // this.apiService.get<Study[]>('study/studylist', params, headers).subscribe(
    //   (response: Study[]) => {
    //     this.data = response;
    //     this.crcsList = response.reduce((acc, study) => acc.concat(study.crcs_list), []); // Aggregate all CRCs


    //   });

    // const tabs = document.getElementById("pills-tab") as HTMLElement;

    // // Check if the tabs element exists
    // if (tabs) {
    //   // Get the offset position of the tabs
    //   const sticky: number = tabs.offsetTop;

    //   // Add the scroll event listener
    //   window.onscroll = function () {
    //     if (window.pageYOffset > sticky) {
    //       this.showSticky = true;
    //       console.log("scroll " + this.showSticky);
    //       tabs.classList.add("sticky");
    //     } else {
    //       console.log("scroll1 " + this.showSticky);
    //       this.showSticky = false;
    //       tabs.classList.remove("sticky");
    //     }
    //   };
    // }
  }
  @HostListener('window:scroll', [])
  onWindowScroll(): void {

    const tabs = document.getElementById("pills-tab") as HTMLElement;

    // Check if the tabs element exists
    if (tabs) {
      // Get the offset position of the tabs
      const sticky: number = tabs.offsetTop;
      const scrolled = window.scrollY;
      if (window.pageYOffset > sticky) {
        this.showSticky = true;
        tabs.classList.add("sticky");
      } else {
        this.showSticky = false;
        tabs.classList.remove("sticky");
      }
    }
    // You can add more logic here based on scroll position
  }
  
  
  scrollToSection(sectionId: string, showSticky: boolean = false) {
    this.activeTab = sectionId;
    const element = document.getElementById(sectionId);
    if (element) {
      const elementPosition = element.getBoundingClientRect().top + window.scrollY;
      let offsetScroll = showSticky ? this.scrollOffset : this.scrollOffset + 50;
      const offsetPosition = elementPosition - offsetScroll;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }


goBack(): void {
  this.router.navigate(['/study-crc-list'], {
    queryParams: {
      page: this.currentPage,
      searchCrcName: this.searchParams.searchCrcName,
      searchStudyName: this.searchParams.searchStudyName,
      searchLocation: this.searchParams.searchLocation,
      searchAssignedBy: this.searchParams.searchAssignedBy
    }
  });
}



}
